export default {
  GET_INGREDIENTS: state => state.ingredients,
  GET_OBJECT_COMPANIES: state => state.objectCompanies,
}
